import { Component, Input, OnInit, OnDestroy } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Subscription } from "rxjs/Subscription";

import { CommercialService, UserService } from "@core/services";
import { User } from "@shared/models";

@Component({
  selector: "app-toll-pass",
  templateUrl: "./toll-pass.component.html",
  styleUrls: ["./toll-pass.component.css"],
})
export class TollPassComponent implements OnInit, OnDestroy {
  @Input("tollPassGroup")
  public tollPassesForm: FormGroup;
  public hideNumberOfPasses = false;
  public AxelCount: string;
  public AxelSelectionDisabled: boolean = false;
  public showNexusAlert = false;
  public user: User;
  private subscription: Subscription;
  public commercial: any;
  private commercialSubscription: Subscription;

  constructor(
    private _userService: UserService,
    private _commercial: CommercialService
  ) {}

  ngOnInit() {
    this.subscription = this._userService
      .getUser()
      .subscribe((user) => (this.user = user));
    this.commercialSubscription = this._commercial
      .getCommercialValue()
      .subscribe((commercial) => (this.commercial = commercial));
    this.tollPassesForm.patchValue({
      PassTypeId: "5",
      NumberOfPasses: "1",
      AxelCount: "2",
      VehicleClass: "3",
    });
    this.AxelCount = "2";
  }

  ngOnDestroy() {
    console.log("this is the commercial object: ", this.commercial);
    this.subscription.unsubscribe();
    this.commercialSubscription.unsubscribe();
  }

  onPassTypeChange(event) {
    const passType = event.target.value;
    if (passType === "3" || passType === "1") {
      if (passType === "3") this.showNexusAlert = true;
      else this.showNexusAlert = false;
      this.hideNumberOfPasses = true;
      console.log("hiding number of passes");
      console.log("tollpasses form: ", this.tollPassesForm);
      this.tollPassesForm.patchValue({ NumberOfPasses: "1" });
    } else {
      this.showNexusAlert = false;
      this.hideNumberOfPasses = false;
    }
  }

  checkSelection(event) {
    const vehicleClass = event.target.value;
    if (vehicleClass === "7" || vehicleClass === "8") {
      //console.log(this.AxelCount);
      this.AxelCount = vehicleClass;
      this.AxelSelectionDisabled = true;
    } else {
      this.AxelCount = "2";
      if (this.AxelSelectionDisabled) {
        this.AxelSelectionDisabled = false;
      }
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/toll-pass/toll-pass.component.ts